import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable, Subject, takeUntil, tap } from 'rxjs';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';
import { LoaderState } from '../../store/loader/loader.state';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private router = inject(Router);
  private loaderService = inject(LoaderService);

  @Input() mainDivClass: '' | 'relative-overlay' = '';
  @Input() containerDivClass: 'fixed-spinner-container' | 'relative-spinner-container' = 'fixed-spinner-container';
  @Input() diameter: number = 100;
  @Input() isRelativeLoader: boolean = false;
  isFullScreenloader$?: Observable<boolean>;
  onDestroy$: Subject<void> = new Subject<void>();
  
  @Input()
  detectRouteTransitions = false;

  constructor() {
    this.isFullScreenloader$ = this.store.select(LoaderState.isLoading);
  }

  ngOnInit(): void {
    if (this.detectRouteTransitions) {
      this.router.events
        .pipe(
          tap((event) => {
            if (event instanceof RouteConfigLoadStart)
              this.loaderService.show();
            else if (event instanceof RouteConfigLoadEnd)
              this.loaderService.hide();
          }),
          takeUntil(this.onDestroy$)
        ).subscribe();
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}